import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { AssetLightbox } from '@/components/assets/asset-lightbox';

const paramsSchema = z.object({
  assetId: z.coerce.number().int().positive(),
});

export const Route = createFileRoute('/_authenticated/assets/$assetId')({
  params: {
    parse: (raw) => paramsSchema.parse(raw),
    stringify: ({ assetId }) => ({ assetId: String(assetId) }),
  },
  component: AssetDetailRoute,
});

function AssetDetailRoute(): React.ReactElement {
  const { assetId } = Route.useParams();
  const navigate = Route.useNavigate();

  return (
    <AssetLightbox
      assetId={assetId}
      onClose={() => void navigate({ to: '/assets', search: (prev) => prev })}
    />
  );
}
